import { UserProfile } from 'types/user-profile';
import fetchWithRetry from './fetch-retry';

export const fetchUsers = async () => await fetchWithRetry<UserProfile[]>(`/api/users`, { method: 'GET' }, []);

export const postUser = async (user: Partial<UserProfile>) =>
  await fetch('/api/users', {
    method: 'POST',
    headers: [
      ['Authorization', `Bearer ${localStorage.getItem('token')}`],
      ['Content-Type', 'application/json']
    ],
    body: JSON.stringify(user)
  });

export const getAuthenticatedUser = async (): Promise<UserProfile | null> =>
  await fetchWithRetry('/api/auth/me', {
    method: 'GET',
    headers: [
      ['Authorization', `Bearer ${localStorage.getItem('token')}`],
      ['Content-Type', 'application/json']
    ]
  }, null)

export const getUser = async (username: string): Promise<UserProfile | null> =>
  await fetchWithRetry(`/api/users/${username}`, {
    method: 'GET',
    headers: [
      ['Authorization', `Bearer ${localStorage.getItem('token')}`],
      ['Content-Type', 'application/json']
    ]
  }, null);


export const updateUser = async (user: Partial<UserProfile>): Promise<Response> => {
  const init: RequestInit = {
    method: 'PUT',
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    }),
    body: JSON.stringify(user)
  };

  return await fetch(`/api/users`, init);
};

export const deactivateUser = async (username: string) =>
  await fetch(`/api/users/${username}/deactivate`, {
    method: 'POST',
    headers: [
      ['Authorization', `Bearer ${localStorage.getItem('token')}`],
      ['Content-Type', 'application/json']
    ]
  });

export const activateUser = async (username: string) =>
  await fetch(`/api/users/${username}/activate`, {
    method: 'POST',
    headers: [
      ['Authorization', `Bearer ${localStorage.getItem('token')}`],
      ['Content-Type', 'application/json']
    ]
  });

export const validateUsername = async (username: string) =>
  await fetch(`/api/users/validation/username/${username}`, {
    method: 'GET',
    headers: [
      ['Authorization', `Bearer ${localStorage.getItem('token')}`],
      ['Content-Type', 'application/json']
    ]
  })

export const validateEmail = async (email: string) =>
  await fetch(`/api/users/validation/email/${email}`, {
    method: 'GET',
    headers: [
      ['Authorization', `Bearer ${localStorage.getItem('token')}`],
      ['Content-Type', 'application/json']
    ]
  })

export const deleteUserByUsername = async (username: string) =>
  await fetch(`/api/users/${username}`, {
    method: 'DELETE',
    headers: [
      ['Authorization', `Bearer ${localStorage.getItem('token')}`],
      ['Content-Type', 'application/json']
    ]
  });

/** Best-effort parse of backend `ErrorResponse` JSON `{ status, message }`. */
export const parseApiErrorMessage = async (response: Response): Promise<string> => {
  try {
    const json: unknown = await response.json();
    if (json && typeof json === 'object' && 'message' in json && typeof (json as { message: unknown }).message === 'string') {
      return (json as { message: string }).message;
    }
  } catch {
    /* empty or non-JSON body */
  }
  return response.statusText || `HTTP ${response.status}`;
};
